import { render, staticRenderFns } from "./ExpoBlackHoleUpgradeRow.vue?vue&type=template&id=39a56dee&scoped=true&"
import script from "./ExpoBlackHoleUpgradeRow.vue?vue&type=script&lang=js&"
export * from "./ExpoBlackHoleUpgradeRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a56dee",
  null
  
)

export default component.exports